// Magic link validity window. Kept short to limit the blast radius of a leaked
// inbox while staying long enough for a user to switch to their email and click
// through. Import-free so the sign-in forms can show the same label the server
// enforces.
export const MAGIC_LINK_EXPIRES_IN_SECONDS = 10 * 60;
export const MAGIC_LINK_EXPIRES_IN_LABEL = "10 minutes";
